const StorageKeys = {
  redux: "root",
  deviceId: "dId",
};

export default StorageKeys;
